import { HOST } from '@/constants/hosts';
import LogoBrewbound from './LogoBrewbound';
import LogoBevNetNosh from './LogoBevNetNosh';
import { cn } from '@/lib/utils';

interface IIconLogoProps {
  numberHost: number;
  className?: string;
  isWhite?: boolean;
}

const IconLogo = ({ numberHost, className, isWhite = false }: IIconLogoProps) => {
  // Logo styles for Brewbound (single logo)
  const logoClass = 'w-[120px] fill-black block mr-4 max-[992px]:w-[95px] max-[992px]:mr-2';

  // Logo styles for BevNet/Nosh (double logo)
  const logoDoubleClass = cn(
    'w-[120px] h-9 object-contain block mr-4 transition-opacity duration-200 hover:opacity-80',
    'max-[992px]:w-[110px] max-[992px]:h-[33px] max-[992px]:mr-3',
    'max-[768px]:w-[100px] max-[768px]:h-[30px] max-[768px]:mr-2'
  );

  const combinedClassName = cn(
    numberHost === HOST.BREWBOUND ? logoClass : logoDoubleClass,
    className
  );

  if (numberHost === HOST.BREWBOUND) {
    return (<LogoBrewbound className={combinedClassName} isWhite={isWhite} />);
  }

  return (<LogoBevNetNosh className={combinedClassName} isWhite={isWhite} />);
};

export default IconLogo;
